export const usersReducer = (state = {loading: true, resultuser: null, users: null, user: null, useractivate: null, deletionResult: null, paymentMethods: [], resultPaymentMethod: null, clients: [], kitchenUsers: [], totalKitchen: 0, totalClients: 0 } , action) => {
    switch (action.type) {
        case 'USER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                users: action.payload
            }
        case 'USER_GET_CLIENT_SUCCESS':
            return {
                ...state,
                loading: false,
                clients: action.payload.users,
                totalClients: action.payload.total
            }
        case 'USER_GET_KITCHEN_SUCCESS':
            return {
                ...state,
                loading: false,
                kitchenUsers: action.payload.users,
                totalKitchen: action.payload.total
            }
        case 'USER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                user: action.payload
            }
        case 'USER_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                resultuser: action.payload.message,
                useractivate: action.payload.idUser
            }
        case 'USER_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultuser: action.payload
            }
        case 'USER_ENABLEDISABLE_SUCCESS':
            return {
                ...state,
                loading:false,
                user: {...state.user, active: action.payload.stateuser},
                resultuser: action.payload.message
            }
        case 'USER_RESET_RESULT':
            return {...state,
                resultuser: null
            }
        case 'USER_REMOVE_SUCCESS':
            return {
                ...state,
                loading: false,
                deletionResult: true
            }
        case 'USER_REMOVE_RESET':
            return {
                ...state,
                deletionResult: null
            }
        case 'USER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'USER_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'USER_GET_PAYMENT_METHODS_SUCCESS':
            return {
                ...state,
                loading: false,
                paymentMethods: action.payload
            }
        case 'USER_ADD_PAYMENT_METHOD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultPaymentMethod: 'addedSuccessfully'
            }
        case 'USER_ADD_PAYMENT_METHOD_ERROR':
            return {
                ...state,
                loading: false,
                resultPaymentMethod: 'errorAdding'
            }
        case 'USER_REMOVE_PAYMENT_METHOD_SUCCESS':
            return {
                ...state, 
                loading: false,
                resultPaymentMethod: 'removedSuccessfully'
            }
        case 'USER_RESET_PAYMENT_METHOD_RESULT':
            return {
                ...state,
                resultPaymentMethod: null
            }
        default:
            return state
    }
}

